<template>
    <div class="training_detial_box">
        <router-view></router-view>
        <div class="submit_button submit" @click="submitBox" v-if="(status === 0 || status === 2) && role == 4">
            <svg data-v-cb772099="" viewBox="0 0 1024 1024" width="1.2em" height="1.2em">
                <path fill="currentColor"
                    d="M352 159.872V230.4a352 352 0 1 0 320 0v-70.528A416.128 416.128 0 0 1 512 960a416 416 0 0 1-160-800.128">
                </path>
                <path fill="currentColor" d="M512 64q32 0 32 32v320q0 32-32 32t-32-32V96q0-32 32-32"></path>
            </svg>
            提交
        </div>
        <div class="submit_button" @click="openAnswerBox" v-if="status === 0 || status === 2">
            <svg data-v-77309f2d="" viewBox="0 0 1024 1024" width="1.2em" height="1.2em">
                <path fill="currentColor"
                    d="M832 384H576V128H192v768h640zm-26.496-64L640 154.496V320zM160 64h480l256 256v608a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V96a32 32 0 0 1 32-32m160 448h384v64H320zm0-192h160v64H320zm0 384h384v64H320z">
                </path>
            </svg>
            作答
        </div>
        <el-drawer title="我是标题" :modal="false" :append-to-body="false" size="400" :wrapperClosable="false"
            :visible.sync="answerBoxVisable" :with-header="false" custom-class="training_answer_drawer">
            <div class="drawer_box">
                <div class="content_box">
                    <div class="first_box" v-for="item in studentTopicList" :key="item.id">
                        <div class="first_title">{{ item.class_name }}</div>
                        <div class="first_box" v-for="childrenItem in item.children" :key="childrenItem.id">
                            <div class="first_name">
                                <!-- 1单选题  2多选题  3判断题  4填空题  5问答题 -->
                                <div class="name" v-html="childrenItem.topic_title"></div>
                                <div class="input_box single_choice" v-if="childrenItem.topic_type == 1">
                                    <el-radio-group v-model="childrenItem.stu_answer">
                                        <el-radio :label="valueIndex"
                                            v-for="(valueItem, valueIndex) in childrenItem.topic_options"
                                            :key="valueIndex">{{ valueItem.name
                                            }}</el-radio>
                                    </el-radio-group>
                                </div>
                                <div class="input_box multiple_choice" v-else-if="childrenItem.topic_type == 2">
                                    <el-checkbox-group v-model="childrenItem.stu_answer">
                                        <el-checkbox :label="valueIndex"
                                            v-for="(valueItem, valueIndex) in childrenItem.topic_options"
                                            :key="valueIndex">{{ valueItem.name
                                            }}</el-checkbox>
                                    </el-checkbox-group>
                                </div>
                                <div class="input_box judgment" v-else-if="childrenItem.topic_type == 3">
                                    <el-radio-group v-model="childrenItem.stu_answer">
                                        <el-radio :label="valueIndex"
                                            v-for="(valueItem, valueIndex) in childrenItem.topic_options"
                                            :key="valueIndex">{{ valueItem.name }}</el-radio>
                                    </el-radio-group>
                                </div>
                                <div class="input_box gap_filling" v-else-if="childrenItem.topic_type == 4">
                                    <el-input
                                        :style="{ width: childrenItem.stu_answer.length == 1 ? '324px' : childrenItem.stu_answer.length == 2 ? '155px' : '100px' }"
                                        v-model="studentValue.value"
                                        v-for="(studentValue, studentIndex) in childrenItem.stu_answer"
                                        :key="studentIndex"></el-input>
                                </div>
                                <div class="input_box" v-else-if="childrenItem.topic_type == 5">
                                    <el-input type="textarea" :maxlength="200" show-word-limit autosize
                                        placeholder="请输入内容" v-model="childrenItem.stu_answer">
                                    </el-input>
                                </div>
                            </div>
                            <div class="second_box">
                                <div class="second_title">{{ childrenItem.class_name }}</div>
                                <div class="first_name" v-for="secondItem in childrenItem.children"
                                    :key="secondItem.id">
                                    <div class="name" v-html="secondItem.topic_title"></div>
                                    <div class="input_box single_choice" v-if="secondItem.topic_type == 1">
                                        <el-radio-group v-model="secondItem.stu_answer">
                                            <el-radio :label="value2Index"
                                                v-for="(value2Item, value2Index) in secondItem.topic_options"
                                                :key="value2Index">{{ value2Item.name }}</el-radio>
                                        </el-radio-group>
                                    </div>
                                    <div class="input_box multiple_choice" v-else-if="secondItem.topic_type == 2">
                                        <el-checkbox-group v-model="secondItem.stu_answer">
                                            <el-checkbox :label="value2Index"
                                                v-for="(value2Item, value2Index) in secondItem.topic_options"
                                                :key="value2Index">{{ value2Item.name }}</el-checkbox>
                                        </el-checkbox-group>
                                    </div>
                                    <div class="input_box judgment" v-else-if="secondItem.topic_type == 3">
                                        <el-radio-group v-model="secondItem.stu_answer">
                                            <el-radio :label="value2Index"
                                                v-for="(value2Item, value2Index) in secondItem.topic_options"
                                                :key="value2Index">{{ value2Item.name }}</el-radio>
                                        </el-radio-group>
                                    </div>
                                    <div class="input_box gap_filling" v-else-if="secondItem.topic_type == 4">
                                        <el-input
                                            :style="{ width: secondItem.stu_answer.length == 1 ? '324px' : secondItem.stu_answer.length == 2 ? '155px' : '100px' }"
                                            v-model="student2Value.value"
                                            v-for="(student2Value, student2Index) in secondItem.stu_answer"
                                            :key="student2Index"></el-input>
                                    </div>
                                    <div class="input_box" v-else-if="secondItem.topic_type == 5">
                                        <el-input type="textarea" :maxlength="200" show-word-limit autosize
                                            placeholder="请输入内容" v-model="secondItem.stu_answer">
                                        </el-input>
                                    </div>
                                </div>
                            </div>
                        </div>


                    </div>
                </div>
                <div class="drawer_box_footer">
                    <el-button class="close_btn" @click="closeDrawer">关闭</el-button>
                    <el-button class="submit_btn" @click="submit">保存</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
export default {
    name: "index",
    components: {},
    data() {
        return {
            answerBoxVisable: false,
            studentTopicList: [],
            status: 0,
            role: 0,
            data: [{ value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" }, { value: "" },]
        };
    },
    created() {

    },
    mounted() {
        this.role = localStorage.getItem("role")
        this.getDetial()
    },
    methods: {
        openAnswerBox() {

            this.answerBoxVisable = true


        },
        getDetial() {
            let params = {
                project_id: Number(localStorage.getItem("project_id")),
                course_id: Number(localStorage.getItem("course_id")),
                course_chapter: this.role == 3 ? Number(localStorage.getItem("teacherChapter")) : Number(localStorage.getItem("studentChapter")),
                course_node: this.role == 3 ? Number(localStorage.getItem("teacherNode")) : Number(localStorage.getItem("studentNode")),
                c_id: this.role == 3 ? Number(localStorage.getItem("class_id")) : Number(localStorage.getItem("c_id")),
                type: Number(localStorage.getItem("project_type"))
            }
            if (Number(localStorage.getItem("project_type")) == 3) {
                delete params.course_id
                delete params.course_chapter
                delete params.course_node
            }
            if (Number(localStorage.getItem("project_type")) == 2) {
                params.course_chapter = -1
                params.course_node = -1
            }
            this.$shttp.axiosGetBy(this.$api.jdTrainingStuTopicList, params, (res) => {
                if (res.code === 200) {
                    console.log(res);
                    this.studentTopicList = res.data.data
                    this.status = res.data.status

                }
            })
        },
        closeDrawer() {
            this.answerBoxVisable = false
        },
        submit() {
            this.$confirm('确定提交表单?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: ''
            }).then(() => {
                //  jdTrainingStuSaveAnswer
                let params = {
                    project_id: Number(localStorage.getItem("project_id")),
                    course_id: Number(localStorage.getItem("course_id")),
                    course_chapter: this.role == 3 ? Number(localStorage.getItem("teacherChapter")) : Number(localStorage.getItem("studentChapter")),
                    course_node: this.role == 3 ? Number(localStorage.getItem("teacherNode")) : Number(localStorage.getItem("studentNode")),
                    c_id: this.role == 3 ? Number(localStorage.getItem("class_id")) : Number(localStorage.getItem("c_id")),
                    content: this.studentTopicList,
                    type: Number(localStorage.getItem("project_type"))
                }
                if (Number(localStorage.getItem("project_type")) == 3) {
                    delete params.course_id
                    delete params.course_chapter
                    delete params.course_node
                }
                if (Number(localStorage.getItem("project_type")) == 2) {
                    params.course_chapter = -1
                    params.course_node = -1
                }
                if (Number(localStorage.getItem("sx_id"))) {
                    params.shixun_id = Number(localStorage.getItem("sx_id"))
                }
                this.$shttp.axiosPost(this.$api.jdTrainingStuSaveAnswer, params, (res) => {
                    if (res.code === 200) {
                        this.$message({
                            type: 'success',
                            message: '保存成功!'
                        });
                        this.answerBoxVisable = false

                    } else {
                        this.$message({
                            type: 'error',
                            message: res.msg
                        });
                    }
                })

            }).catch(() => {

            });
        },
        submitBox() {
            let params = {
                project_id: Number(localStorage.getItem("project_id")),
                course_id: Number(localStorage.getItem("course_id")),
                course_chapter: this.role == 3 ? Number(localStorage.getItem("teacherChapter")) : Number(localStorage.getItem("studentChapter")),
                course_node: this.role == 3 ? Number(localStorage.getItem("teacherNode")) : Number(localStorage.getItem("studentNode")),
                c_id: this.role == 3 ? Number(localStorage.getItem("class_id")) : Number(localStorage.getItem("c_id")),
                type: Number(localStorage.getItem("project_type"))
            }
            if (Number(localStorage.getItem("project_type")) == 3) {
                delete params.course_id
                delete params.course_chapter
                delete params.course_node
            }
            if (Number(localStorage.getItem("project_type")) == 2) {
                params.course_chapter = -1
                params.course_node = -1
            }
            if (Number(localStorage.getItem("sx_id"))) {
                params.shixun_id = Number(localStorage.getItem("sx_id"))
            }
            this.$shttp.axiosPost(this.$api.jdTrainingStuSubmitAnswer, params, (res) => {
                if (res.code === 200) {
                    this.$message({
                        type: 'success',
                        message: '提交成功!'
                    });
                    this.getDetial()
                } else if (res.code == 400 && res.msg == "答题记录不存在！") {
                    this.$message.warning("未作答，无法提交")
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    },
    beforeDestroy() {
        if (Number(localStorage.getItem("sx_id"))) {
            localStorage.removeItem("sx_id")
        }
    }
};

</script>

<style scoped lang="scss">
.training_detial_box {
    .submit_button {
        position: fixed;
        top: calc(10vh + 100px);
        right: 0;
        z-index: 99;
        padding: 10px 8px;
        text-align: center;
        box-sizing: border-box;
        width: 45px;
        line-height: 20px;
        color: #fff;
        background: #1966ff;
        border-radius: 10px 0 0 10px;
        box-shadow: 0 0 8px #1966ff99;
        display: flex;
        flex-direction: column;
        align-items: center;
        cursor: pointer;
    }

    .submit {
        top: calc(10vh + 20px);
        background: #f56c6c;
        box-shadow: 0 0 8px #f56c6c;
    }

}

.drawer_box {
    width: 400px;

    .content_box {
        width: 100%;
        height: calc(100vh - 60px);
        box-sizing: border-box;
        overflow-y: auto;

        .first_box {
            width: 100%;

            .first_title {
                width: 100%;
                color: #000000;
                font-size: 16px;
                padding: 16px;
                box-sizing: border-box;
                border-bottom: 1px solid #f7f8f9;
            }

            .first_box {
                padding: 10px 16px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;

                .first_name {
                    border-bottom: 1px solid #f7f8f9;

                    .name {
                        font-size: 14px;
                        color: #909399;
                        line-height: 24px;
                    }

                    .input_box {
                        width: 100%;
                    }

                    .single_choice {

                        .el-radio-group {
                            display: flex;
                            flex-direction: column;


                            .el-radio {
                                margin: 10px 0;
                                color: #909399;
                                max-width: 100%;
                                word-wrap: break-word;
                                word-break: break-all;
                            }
                        }
                    }

                    .multiple_choice {
                        .el-checkbox-group {
                            display: flex;
                            flex-direction: column;

                            .el-checkbox {
                                margin: 10px 0;
                                color: #909399;
                            }

                        }

                    }

                    .judgment {
                        .el-radio-group {
                            display: flex;
                            // flex-direction: column;
                            margin: 10px 0;

                            .el-radio {

                                color: #909399;
                                display: flex;
                                align-items: center;
                            }
                        }
                    }

                    .gap_filling {
                        display: flex;
                        flex-wrap: wrap;
                        gap: 12px;
                    }
                }

                .second_box {
                    font-size: 14px;
                    color: #909399;
                    line-height: 24px;

                    .first_name {
                        padding: 10px 16px;
                        border-bottom: 1px solid #f7f8f9;

                        .single_choice {

                            .el-radio-group {
                                display: flex;
                                flex-direction: column;

                                .el-radio {
                                    margin: 10px 0;
                                    color: #909399;
                                    display: flex;
                                    align-items: center;
                                }
                            }
                        }

                        .multiple_choice {
                            .el-checkbox-group {
                                display: flex;
                                flex-direction: column;

                                .el-checkbox {
                                    margin: 10px 0;
                                    color: #909399;
                                }

                            }

                        }

                        .judgment {
                            .el-radio-group {
                                display: flex;
                                // flex-direction: column;
                                margin: 10px 0;

                                .el-radio {

                                    color: #909399;
                                }
                            }
                        }

                        .gap_filling {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 12px;
                        }
                    }


                }
            }


        }
    }


    .drawer_box_footer {
        position: fixed;
        width: 400px;
        height: 60px;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #fff;
        z-index: 10000;

        .close_btn {
            width: 60px;
            height: 32px;
            padding: 8px 15px;
            color: #606266;
            background: #fff;
            border: 1px solid #dcdfe6;
        }

        .submit_btn {
            width: 60px;
            height: 32px;
            padding: 8px 15px;
            background: #2a55e5;
            color: #fff;
        }

    }
}

::v-deep .el-radio {
    display: flex;
    align-items: center;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none;
}

::v-deep .el-radio__label {
    display: block;
    width: 96%;
    white-space: normal
}

::v-deep .el-checkbox {
    display: flex;
    align-items: center;
}

::v-deep .el-checkbox__label {
    display: block;
    width: 96%;
    white-space: normal
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #006eff !important;

}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #006eff;
    border-color: #006eff;
}

::v-deep .el-input__inner {
    border: 1px solid transparent;
    border-bottom: 1px solid #e0e2e4;
    margin-bottom: 10px;
    margin-right: 10px;
    border-radius: 0;

}

::v-deep .el-textarea__inner {
    width: 335px;
    min-height: 120px !important;
    border: 1px solid #e0e2e4;
    // border-bottom: 1px solid #e0e2e4;
    // border-radius: 0;
    resize: none;
}

/* modal=false 时 drawer 全屏 wrapper 仍会挡住下方数据中心 tab 点击 */
::v-deep .el-drawer__wrapper {
    pointer-events: none;
}

::v-deep .el-drawer__container {
    pointer-events: none;
}

::v-deep .training_answer_drawer {
    pointer-events: auto;
}
</style>
